import { IconProps } from ".";

export const DigitalKeyIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.6738 13.4275V11.0723V13.4275Z" fill="#FAFAFA" />
      <path
        d="M10.6738 13.4275V11.0723"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6738 2.57031V4.92561"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4756 11.0723V12.4043H13.9999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4756 4.92578V3.59375H13.9999"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.87192 11.0723V12.4043H7.34766"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.87192 4.92578V3.59375H7.34766"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4914 7.99947L12.2307 6.7388L11.2963 7.48353L10.5215 6.76227L9.56353 7.48353L8.84227 6.76333L7.88907 6.76413C7.41367 5.68127 6.3319 4.92578 5.07347 4.92578C3.37604 4.92578 2 6.30182 2 7.99927C2 9.69667 3.37604 11.0727 5.07347 11.0727C6.32064 11.0727 7.39433 10.3287 7.87613 9.26133L12.2307 9.26013L13.4914 7.99947Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.21679 8.65101C3.85743 8.29161 3.85743 7.70901 4.21679 7.34961"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
